import { studentUrl } from '@/config'

const { XLSX } = window
const xlsxMagicNumber = [80, 75, 3, 4].toString()

export const date2local = dateString => {
  const date = new Date(dateString)
  const locale = navigator.language
  const format = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  }
  const formatter = new Intl.DateTimeFormat(locale, format)
  return formatter.format(date)
}

export const fullName = user => {
  return [
    user.first_name,
    user.last_name
  ].filter(Boolean).join(' ')
}

export const truncate = (str, n) => {
  return (str.length > n) ? str.substr(0, n - 1) + '&hellip;' : str
}

export const objs2ids = objList => objList.map(obj => obj.id)

export const deepCopy = (obj) => {
  if (typeof obj !== 'object' || obj === null) {
    return obj
  }

  const result = Array.isArray(obj) ? [] : {}

  for (const key in obj) {
    const value = obj[key]

    result[key] = deepCopy(value)
  }

  return result
}

export const xlsxToJSON = (file) => {
  return new Promise((resolve, reject) => {
    if (!file) return resolve(undefined)

    const reader = new FileReader()
    reader.onload = function (e) {
      try {
        const data = new Uint8Array(e.target.result)
        if (!(data.slice(0, 4).toString() === xlsxMagicNumber)) reject(Error('Not an XLSX file.'))

        const workbook = XLSX.read(data, { type: 'array' })
        const sheet = workbook.Sheets[workbook.SheetNames[0]]
        resolve(XLSX.utils.sheet_to_json(sheet))
      } catch (e) {
        reject(e)
      }
    }
    reader.readAsArrayBuffer(file)
  })
}

export const saveJSONAsXLSX = (json, name) => {
  const wb = XLSX.utils.book_new()
  const ws = XLSX.utils.json_to_sheet(json)
  XLSX.utils.book_append_sheet(wb, ws)
  XLSX.writeFile(wb, name + `-${Date.now()}.xlsx`)
}

export const makeSessionLinks = (sessions) => {
  return sessions.map(session => {
    return { email: session.email, name: fullName(session), studentUrl: studentUrl + session.id }
  })
}

export const validateExamDate = (dateStart, dateEnd) => {
  const start = new Date(dateStart)
  const end = new Date(dateEnd)

  return (end - start) >= 0
}

export const unpackDetails = (errors, details) => {
  for (const field of Object.keys(errors)) {
    if (details[field]) {
      details[field].forEach(detail => errors[field].push(detail))
    }
  }
}
